import { Context } from "@nuxt/types";

export default ({ $axios, $config }: Context): void => {
  $axios.onRequest((config) => {
    config.url = `${$config.apiUrl}${config.url}`;
  });
};
